export default {
  //支持米家
  support_mi_A: 'The product supports Mi Home\'s "Chinese mainland" server. ',
  support_mi_B:
    "The products support Mi Home's servers in Chinese mainland, EU and UK. ",
  support_mi_C:
    "The products support Mi Home's servers in Chinese mainland, EU, UK and Russia. ",
};
